export function parseExpiryTime(expiry: string): number {
  // Перевод в миллисекунды
  const units = { s: 1000, m: 60000, h: 3600000, d: 86400000 };
  const match = expiry.match(/^(\d+)([smhd])$/);

  if (!match) {
    throw new Error(`Invalid expiry format: ${expiry}`);
  }

  const [, value, unit] = match;
  return parseInt(value) * units[unit as keyof typeof units];
}
